<template>
  <div>角色管理</div>
</template>

<script>
export default {
  name: "Role"
}
</script>

<style scoped>

</style>